import { AuthenticatorType } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Icon, IconName, SelectionCardGroup } from '@optimus-web/core';

interface TwoFactorAuthenticationSelectionCardGroupProps {
    inputValue: AuthenticatorType;
    onChange: (type: AuthenticatorType) => void;
}

export function TwoFactorAuthenticationSelectionCardGroup({
    inputValue,
    onChange,
}: TwoFactorAuthenticationSelectionCardGroupProps) {
    return (
        <SelectionCardGroup
            label={<LocalizedText textKey={TextKey.AuthenticationMethod} />}
            type="radio"
            cardVariant="horizontal"
            options={authenticatorMethods}
            compact
            inputValue={inputValue}
            onChange={(e) => onChange(e.target.value as AuthenticatorType)}
        />
    );
}

const authenticatorMethods = [
    {
        value: AuthenticatorType.Email,
        label: <LocalizedText textKey={TextKey.TwoFactorAuthenticationEmailMethodLabel} />,
        description: <LocalizedText textKey={TextKey.TwoFactorAuthenticationEmailLinkMethodDescription} />,
        name: '2fa-route',
        media: <Icon value={IconName.Mails} size="medium" />,
    },
    {
        value: AuthenticatorType.Google,
        label: <LocalizedText textKey={TextKey.TwoFactorAuthenticationAppMethodLabel} />,
        description: <LocalizedText textKey={TextKey.TwoFactorAuthenticationAppMethodDescription} />,
        name: '2fa-route',
        media: <Icon value={IconName.Phone} size="medium" />,
    },
];
